<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="true"
  [maximizable]="true"
  [baseZIndex]="10000"
  [style]="{ width: '70vw', maxWidth: '1200px' }"
  styleClass="ticket-modal-dialog"
  (onHide)="onHide()"
>
  <ng-template pTemplate="header">
    <h2 class="text-xl font-semibold">
      {{ ticket ? "Edit Ticket" : "Create Ticket" }}
    </h2>
  </ng-template>

  <form [formGroup]="ticketForm">
    <p-tabView [(activeIndex)]="activeTabIndex">

      <!-- GENERAL TAB -->
      <p-tabPanel header="General">
        <div class="p-6 space-y-6">

          <!-- Title -->
          <div class="grid grid-cols-12 gap-4 items-center">
            <label class="col-span-3 font-semibold">
              Title <span class="text-red-500">*</span>
            </label>

            <div class="col-span-9">
              <input
                type="text"
                pInputText
                formControlName="title"
                class="w-full"
                placeholder="Enter ticket title"
              />
            </div>
          </div>

          <!-- Category -->
          <div class="grid grid-cols-12 gap-4 items-center">
            <label class="col-span-3 font-semibold">
              Category <span class="text-red-500">*</span>
            </label>

            <div class="col-span-9">
              <p-dropdown
                formControlName="category"
                [options]="categoryOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Select Category"
                class="w-full"
              ></p-dropdown>
            </div>
          </div>

          <!-- Priority -->
          <div class="grid grid-cols-12 gap-4 items-center">
            <label class="col-span-3 font-semibold">
              Priority <span class="text-red-500">*</span>
            </label>

            <div class="col-span-9">
              <p-dropdown
                formControlName="priority"
                [options]="priorityOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Select Priority"
                class="w-full"
              ></p-dropdown>
            </div>
          </div>

          <!-- Description -->
          <div class="grid grid-cols-12 gap-4">
            <label class="col-span-3 font-semibold">
              Description
            </label>

            <div class="col-span-9">
              <div
                #descriptionEditor
                contenteditable="true"
                class="border p-3 rounded min-h-[150px]"
                (input)="onDescriptionInput()"
              ></div>
            </div>
          </div>

        </div>
      </p-tabPanel>

      <!-- DETAILED TAB -->
      <p-tabPanel header="Detailed">

        <div class="p-6 grid grid-cols-2 gap-6">

          <!-- Proposal -->
          <div>
            <label class="font-semibold block mb-2">
              Proposal
            </label>

            <p-dropdown
              formControlName="proposal"
              [options]="proposalOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Select Proposal"
              (onChange)="onProposalChange($event)"
              class="w-full"
            ></p-dropdown>
          </div>

          <!-- Proposal Step -->
          <div>
            <label class="font-semibold block mb-2">
              Proposal Step
            </label>

            <p-dropdown
              formControlName="proposalStep"
              [options]="proposalStepOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Select Step"
              [filter]="true"
              class="w-full"
            ></p-dropdown>
          </div>

        </div>

      </p-tabPanel>

    </p-tabView>
  </form>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <button
      pButton
      label="Cancel"
      class="p-button-secondary"
      (click)="onCancel()"
    ></button>

    <button
      pButton
      label="Submit"
      class="p-button-primary"
      (click)="onSubmit()"
    ></button>
  </ng-template>
</p-dialog>

<p-toast></p-toast>